import { Menu, MenuItem, ButtonBase } from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import { useState } from 'react'

import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import useStyles from './styles/PoliciesTable.styles'

interface PolicyRowMenuProps {
  openModal?: () => void
  id: string
  providerCode: string
}

export const PolicyRowMenu: React.FC<PolicyRowMenuProps> = ({
  openModal = () => {},
  id,
  providerCode
}) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null)

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <ButtonBase onClick={handleClick} className={classes.moreIcon}>
        <MoreIcon />
      </ButtonBase>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}>
        <MenuItem
          component={LocalizedLink}
          to={`/policies/amendment-policies/${providerCode}/${id}/edit`}>
          {getTranslate('Edit Policy')}
        </MenuItem>
        <MenuItem button onClick={openModal}>
          {getTranslate('View Policy Table')}
        </MenuItem>
      </Menu>
    </>
  )
}
